// Initialise and observe animate on scroll
if (document.body.classList.contains('cc-animate-enabled')) {
  if ('IntersectionObserver' in window && 'MutationObserver' in window) {
    const selector = '[data-cc-animate]:not(.cc-animate-init)';
    const intersectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !entry.target.classList.contains('cc-animate-in')) {
          entry.target.classList.add('cc-animate-in');
          observer.unobserve(entry.target);
        }
      });
    });

    const initializeElement = (elem) => {
      if (elem.dataset.ccAnimateDelay) elem.style.animationDelay = elem.dataset.ccAnimateDelay;
      if (elem.dataset.ccAnimateDuration) elem.style.animationDuration = elem.dataset.ccAnimateDuration;
      if (elem.dataset.ccAnimate) elem.classList.add(elem.dataset.ccAnimate);
      elem.classList.add('cc-animate-init');
      intersectionObserver.observe(elem);
    };

    const initAnimateOnScroll = (root = document) => {
      if (root instanceof Element && root.matches(selector)) initializeElement(root);
      root.querySelectorAll?.(selector).forEach(initializeElement);
    };

    const aosMinWidth = getComputedStyle(document.documentElement)
      .getPropertyValue('--aos-min-width') || '0';
    const mq = window.matchMedia(`(min-width: ${aosMinWidth}px)`);
    if (mq.matches) {
      initAnimateOnScroll();

      // Dynamic sections and modal content are inspected locally. The old
      // observer rescanned the entire document after every child insertion.
      const observeDynamicContent = () => {
        const observer = new MutationObserver((records) => {
          records.forEach((record) => {
            record.addedNodes.forEach((node) => {
              if (node instanceof Element) initAnimateOnScroll(node);
            });
          });
        });
        observer.observe(document.body, {
          subtree: true,
          childList: true
        });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeDynamicContent, { once: true });
      } else {
        observeDynamicContent();
      }
    } else {
      document.body.classList.remove('cc-animate-enabled');

      try {
        mq.addEventListener('change', (event) => {
          if (event.matches) {
            document.body.classList.add('cc-animate-enabled');
            setTimeout(initAnimateOnScroll, 100);
          }
        });
      } catch (e) {
        // Legacy browsers (Safari < 14), rely on the animations being shown by the line above the
        // try
      }
    }
  } else {
    // Reveal all the animations
    document.body.classList.remove('cc-animate-enabled');
  }
}
